import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useClients } from '../hooks/useClients';

function ClientSwitcher() {
  const { clients } = useClients();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="client-switcher" ref={ref}>
      <button className="client-switcher-button" onClick={() => setOpen(!open)}>
        Clientes ({clients.length})
        <span>{open ? '\u25B2' : '\u25BC'}</span>
      </button>
      {open && (
        <div className="client-switcher-dropdown">
          {clients.map(client => (
            <Link
              key={client.id}
              to={`/client/${client.id}`}
              className="client-switcher-item"
              onClick={() => setOpen(false)}
            >
              {client.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default ClientSwitcher;
